import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Warehouse} from '../../shared/CommonInterfaces';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import ManifestDetail from './ManifestDetail';
import ManifestIndex from './ManifestIndex';

interface RouteProps {
  selectedWarehouse: Warehouse;
  activeWarehouses: Warehouse[];
  inactiveWarehouses?: Warehouse[];
  parcelTrailerLoadingEnabled: boolean;
  freightTrailerLoadingEnabled: boolean;
}
interface AppProps extends RouteProps {
  authenticityToken: string;
}

export const Routes: React.FC<RouteProps> = (props) => {
  return (
    <Switch>
      <Route
        path="/wh/outbound_manifests"
        exact
        render={(routeProps) => <ManifestIndex {...routeProps} {...props} />}
      />

      <Route
        path="/wh/outbound_manifests/:id"
        exact
        render={(routeProps) => <ManifestDetail {...routeProps} {...props} />}
      />
    </Switch>
  );
};

const OutboundManifestsApp: React.FC<AppProps> = (props) => {
  const {authenticityToken, ...routeProps} = props;
  const flexeContextValue: FlexeContextValues = {
    authenticityToken
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <Router>
        <Routes {...routeProps} />
      </Router>
    </FlexeContext.Provider>
  );
};

export default OutboundManifestsApp;
